import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../lib/auth";

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const { refresh, user } = useAuth();
  const { t } = useTranslation();
  useEffect(() => {
    refresh().then(() => navigate("/profile"));
    // eslint-disable-next-line
  }, []);
  return <div className="app-container py-20 text-white/70" data-testid="auth-callback-status">{t("auth.signing_in")}</div>;
}
